import { classNames } from "helpers/themeHelpers";
import { useTheme } from "styled-components";
import { FC } from "react";
import { IWidget } from "../../../../types/home";
import { MAX_POSTS_IN_LATEST_POSTS_NO_IMAGE } from "utils/constants";
import { gtmPostLatestAds } from "GTMs/actions/homeActions";
import { viewListingAction } from "../../../../../../../libs/logging/helpers/loggingActions";
import {
  EnumCellType,
  EnumLoggingScreenNames,
  EnumUxTypes,
} from "../../../../../../../libs/logging/types/loggingTypes";
import { linkToListingView } from "../../../../helper/links";

interface IProps {
  widget: IWidget;
}

const HomeWidgetText: FC<IProps> = ({ widget }) => {
  const { isDesktop, isMobile, device } = useTheme();

  const loggingObj = (item) => {
    return {
      postId: item?.id,
      city_name: item.city_reporting_name,
      neighborhood: item.neighborhood_reporting_name,
      subcategory: item.subcategory_reporting_name,
      services: item?.services || [],
      category: item.category_reporting_name,
    };
  };
  const onPostClick = (item) => {
    gtmPostLatestAds(
      widget?.gtm_config?.post?.eventAction,
      widget?.gtm_config?.post?.eventLabel,
      {
        Category: item.category_reporting_name,
        SubCategory: item.subcategory_reporting_name,
      }
    );
    viewListingAction({
      listingData: loggingObj(item) as any,
      currentScreen: EnumLoggingScreenNames.HOME,
      widgetName: widget?.gtm_config?.post?.widgetName,
      ux_type: EnumUxTypes.NA,
      cellType: EnumCellType.NA,
      referenceId: item?.member_id,
    });
  };
  return (
    <div
      {...classNames(
        isDesktop && "withNoImage flex flexSpaceBetween flexWrap mt-8"
      )}
    >
      {widget &&
        widget?.items
          ?.slice(0, MAX_POSTS_IN_LATEST_POSTS_NO_IMAGE[device])
          .map((item, index: number) => {
            return (
              <a
                href={linkToListingView(widget, item)}
                key={index}
                {...classNames(
                  "blackColor mt-16",
                  isMobile && "block",
                  index < 2 && "pb-16 borderBottomDashed"
                )}
                onClick={() => onPostClick(item)}
                target={isDesktop ? "_blank" : "_self"}
              >
                <strong {...classNames(isDesktop && "font-18")}>
                  {item.highlights.replaceAll("\u200F","")}
                </strong>
                <p {...classNames("trim mt-16", isMobile && "font-14")}>
                  {item.title}
                </p>
              </a>
            );
          })}
    </div>
  );
};
export default HomeWidgetText;
